<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-stat-row">
    <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4,5]"></div>
  </div>
  <div class="dsk-split dsk-split-3-2" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
        <div class="dsk-badge dsk-pulse" style="width:32px;height:22px;border-radius:20px"></div>
      </div>
      <div class="dsk-panel-body" style="gap:8px">
        <div *ngFor="let m of [1,2,3,4,5,6]" style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:#faf8ff;border-radius:9px;border:1px solid #ece9e6">
          <div class="dsk-pulse" style="width:36px;height:36px;border-radius:50%;flex-shrink:0"></div>
          <div style="flex:1;display:flex;flex-direction:column;gap:5px">
            <div class="dsk-cell dsk-pulse" style="width:110px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="width:75px;height:11px"></div>
          </div>
          <div class="dsk-badge dsk-pulse" style="width:58px;border-radius:20px"></div>
        </div>
      </div>
    </div>
    <div style="display:flex;flex-direction:column;gap:12px">
      <div class="dsk-pulse" style="height:120px;border-radius:12px"></div>
      <div class="dsk-pulse" style="height:120px;border-radius:12px"></div>
      <div class="dsk-pulse" style="height:100px;border-radius:12px"></div>
    </div>
  </div>
  <div class="dsk-split dsk-split-2-1" style="align-items:flex-start">
    <div class="dsk-pulse" style="height:190px;border-radius:12px"></div>
    <div class="dsk-pulse" style="height:190px;border-radius:12px"></div>
  </div>
</div>

<div class="mgr-canvas" *ngIf="!loading">

  <app-announcement-widget></app-announcement-widget>

  <app-pulse-widget></app-pulse-widget>

  <div class="kpi-row">

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--primary">
        <span class="material-symbols-outlined">groups</span>
      </div>
      <div class="kpi-body">
        <p class="kpi-label">Total Team Members</p>
        <p class="kpi-value">{{ teamSize }}</p>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--green">
        <span class="material-symbols-outlined">how_to_reg</span>
      </div>
      <div class="kpi-body">
        <p class="kpi-label">Present Today</p>
        <p class="kpi-value">{{ presentToday }}</p>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--blue">
        <span class="material-symbols-outlined">flight_takeoff</span>
      </div>
      <div class="kpi-body">
        <p class="kpi-label">On Leave</p>
        <p class="kpi-value">{{ onLeaveToday }}</p>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--danger">
        <span class="material-symbols-outlined">person_off</span>
      </div>
      <div class="kpi-body">
        <p class="kpi-label">Absent</p>
        <p class="kpi-value">{{ absentToday }}</p>
      </div>
    </div>

    <div class="kpi-card">
      <div class="kpi-icon kpi-icon--muted">
        <span class="material-symbols-outlined">home_work</span>
      </div>
      <div class="kpi-body">
        <p class="kpi-label">WFH</p>
        <p class="kpi-value">{{ wfhToday }}</p>
      </div>
    </div>

  </div>

  <div class="mid-row">

    <div class="surface-card att-table-card">
      <div class="card-header">
        <h2 class="card-title">Team Attendance</h2>
        <button class="link-btn" (click)="viewAllAttendance()">View All</button>
      </div>

      <div class="table-scroll">
        <table class="att-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Status</th>
              <th>Time In</th>
              <th>Hours</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let emp of liveOnTime.slice(0, 4); let i = index">
              <tr [class.row-alt]="i % 2 !== 0">
                <td class="emp-cell">
                  <div class="emp-av emp-av--primary">{{ getInitials(emp.firstName, emp.lastName) }}</div>
                  <div class="emp-info">
                    <p class="emp-name">{{ emp.firstName }} {{ emp.lastName }}</p>
                    <p class="emp-dept">{{ emp.department || emp.departmentName || 'Engineering' }}</p>
                  </div>
                </td>
                <td>
                  <span class="status-badge" [ngClass]="emp.attStatus === 'wfh' ? 'status-wfh' : 'status-present'">
                    {{ emp.attStatus === 'wfh' ? 'WFH' : 'Present' }}
                  </span>
                </td>
                <td class="muted-text">{{ emp.checkIn || '—' }}</td>
                <td class="hours-text">{{ getHoursWorked(emp.checkIn) }}</td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let emp of liveLate.slice(0, 2); let i = index">
              <tr [class.row-alt]="(liveOnTime.length + i) % 2 !== 0">
                <td class="emp-cell">
                  <div class="emp-av emp-av--amber">{{ getInitials(emp.firstName, emp.lastName) }}</div>
                  <div class="emp-info">
                    <p class="emp-name">{{ emp.firstName }} {{ emp.lastName }}</p>
                    <p class="emp-dept">{{ emp.department || emp.departmentName || 'Team Member' }}</p>
                  </div>
                </td>
                <td><span class="status-badge status-late">Late</span></td>
                <td class="muted-text">{{ emp.checkIn || '—' }}</td>
                <td class="hours-text">{{ getHoursWorked(emp.checkIn) }}</td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let emp of liveOnLeave.slice(0, 2); let i = index">
              <tr [class.row-alt]="(liveOnTime.length + liveLate.length + i) % 2 !== 0">
                <td class="emp-cell">
                  <div class="emp-av emp-av--blue">{{ getInitials(emp.firstName, emp.lastName) }}</div>
                  <div class="emp-info">
                    <p class="emp-name">{{ emp.firstName }} {{ emp.lastName }}</p>
                    <p class="emp-dept">{{ emp.department || emp.departmentName || 'Team Member' }}</p>
                  </div>
                </td>
                <td><span class="status-badge status-leave">On Leave</span></td>
                <td class="muted-text">—</td>
                <td class="hours-text">—</td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let emp of liveAbsentees.slice(0, 2); let i = index">
              <tr [class.row-alt]="(liveOnTime.length + liveLate.length + liveOnLeave.length + i) % 2 !== 0">
                <td class="emp-cell">
                  <div class="emp-av emp-av--danger">{{ getInitials(emp.firstName, emp.lastName) }}</div>
                  <div class="emp-info">
                    <p class="emp-name">{{ emp.firstName }} {{ emp.lastName }}</p>
                    <p class="emp-dept">{{ emp.department || emp.departmentName || 'Team Member' }}</p>
                  </div>
                </td>
                <td><span class="status-badge status-absent">Absent</span></td>
                <td class="muted-text">—</td>
                <td class="hours-text">—</td>
              </tr>
            </ng-container>

            <tr *ngIf="teamSize === 0">
              <td colspan="4" class="empty-cell">No team members found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="surface-card donut-card">
      <h2 class="card-title" style="padding:16px 20px 0">Attendance by Department</h2>

      <div class="donut-wrap">
        <svg viewBox="0 0 120 120" class="donut-svg">
          <circle cx="60" cy="60" r="48" fill="none" stroke="#eaedff" stroke-width="14"/>

          <circle cx="60" cy="60" r="48" fill="none" stroke="#8b1a1a" stroke-width="14"
            stroke-linecap="butt"
            [attr.stroke-dasharray]="arcLen(presentToday, teamSize) + ' ' + 301.6"
            [attr.stroke-dashoffset]="arcOffset(0, teamSize)"/>

          <circle cx="60" cy="60" r="48" fill="none" stroke="#2563eb" stroke-width="14"
            stroke-linecap="butt"
            [attr.stroke-dasharray]="arcLen(onLeaveToday, teamSize) + ' ' + 301.6"
            [attr.stroke-dashoffset]="arcOffset(presentToday, teamSize)"/>

          <circle cx="60" cy="60" r="48" fill="none" stroke="#dc2626" stroke-width="14"
            stroke-linecap="butt"
            [attr.stroke-dasharray]="arcLen(absentToday, teamSize) + ' ' + 301.6"
            [attr.stroke-dashoffset]="arcOffset(presentToday + onLeaveToday, teamSize)"/>

          <text x="60" y="56" text-anchor="middle" font-size="20" font-weight="700" fill="#131b2e" font-family="Inter,sans-serif">
            {{ attendancePct }}%
          </text>
          <text x="60" y="70" text-anchor="middle" font-size="8" fill="#58413f" font-family="Inter,sans-serif">Overall</text>
        </svg>
      </div>

      <div class="donut-legend">
        <div class="legend-item">
          <span class="legend-dot" style="background:#8b1a1a"></span>
          <span class="legend-text">Present ({{ teamSize > 0 ? ((presentToday / teamSize) * 100 | number:'1.0-0') : 0 }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background:#2563eb"></span>
          <span class="legend-text">On Leave ({{ teamSize > 0 ? ((onLeaveToday / teamSize) * 100 | number:'1.0-0') : 0 }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background:#dc2626"></span>
          <span class="legend-text">Absent ({{ teamSize > 0 ? ((absentToday / teamSize) * 100 | number:'1.0-0') : 0 }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot" style="background:#64748b"></span>
          <span class="legend-text">WFH ({{ teamSize > 0 ? ((wfhToday / teamSize) * 100 | number:'1.0-0') : 0 }}%)</span>
        </div>
      </div>
    </div>

  </div>

  <div class="bot-row">

    <div class="surface-card">
      <div class="card-header">
        <h2 class="card-title">Pending Approvals</h2>
        <span class="badge-count" *ngIf="pendingLeaveApprovals.length > 0">
          {{ pendingLeaveApprovals.length }}
        </span>
      </div>

      <div class="approvals-list" *ngIf="pendingLeaveApprovals.length > 0">
        <div class="approval-item" *ngFor="let leave of pendingLeaveApprovals">
          <div class="emp-av emp-av--primary">
            {{ getInitials((leave.employeeName || 'EM').split(' ')[0], (leave.employeeName || 'EM').split(' ')[1] || '') }}
          </div>
          <div class="approval-info">
            <p class="approval-name">{{ leave.employeeName }}</p>
            <div class="approval-meta">
              <span class="leave-type-badge">{{ leave.leaveType }}</span>
              <span class="approval-dates">{{ fmtDate(leave.startDate) }} – {{ fmtDate(leave.endDate) }}</span>
            </div>
          </div>
          <div class="approval-actions">
            <button class="action-btn action-btn--reject" (click)="rejectLeave(leave.id)" title="Reject">
              <span class="material-symbols-outlined">close</span>
            </button>
            <button class="action-btn action-btn--approve" (click)="approveLeave(leave.id)" title="Approve">
              <span class="material-symbols-outlined">check</span>
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="pendingLeaveApprovals.length === 0">
        <span class="material-symbols-outlined empty-icon">event_available</span>
        <p class="empty-text">No pending approvals</p>
      </div>
    </div>

    <div class="surface-card progress-card">
      <div class="card-header">
        <h2 class="card-title">Attendance by Department</h2>
        <span class="card-subtitle">Today</span>
      </div>

      <div class="progress-list" *ngIf="deptStats.length > 0">
        <div class="progress-item" *ngFor="let dept of deptStats">
          <div class="progress-header">
            <span class="progress-name">{{ dept.name }}</span>
            <span class="progress-pct" [style.color]="dept.color">{{ dept.pct }}%</span>
          </div>
          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="dept.pct" [style.background]="dept.color"></div>
          </div>
          <p class="progress-sub">{{ dept.present }} of {{ dept.total }} members present</p>
        </div>
      </div>

      <div class="progress-list" *ngIf="deptStats.length === 0 && teamSize > 0">
        <div class="progress-item">
          <div class="progress-header">
            <span class="progress-name">Team Overall</span>
            <span class="progress-pct" style="color:#8b1a1a">{{ attendancePct }}%</span>
          </div>
          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="attendancePct" style="background:#8b1a1a"></div>
          </div>
          <p class="progress-sub">{{ presentToday }} of {{ teamSize }} members present</p>
        </div>
      </div>

      <div class="empty-state" *ngIf="teamSize === 0">
        <span class="material-symbols-outlined empty-icon">analytics</span>
        <p class="empty-text">No team data yet</p>
      </div>
    </div>

  </div>

</div>
